
























































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import { PositionDataModule } from '@/app/store/modules/position'

@Component({
  components: {
    'modal-delete': ModalDelete,
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public fields: any[] | undefined
  @Prop({}) public filter

  public code = ''
  public description = ''

  public deletePositionData = {
    id: 'delete-position',
    idData: 0,
    description: '',
  }

  public funcDeletePositionData(item, index, button) {
    this.deletePositionData.description = item.description
    this.deletePositionData.idData = item.id
    this.$root.$emit('bv::show::modal', this.deletePositionData.id, button)
  }

  public funcDelete() {
    const ids = [this.deletePositionData.idData]
    PositionDataModule.deletePosition({ ids })
    this.$root.$emit('bv::hide::modal', this.deletePositionData.id)
  }

  public postData = {
    id: 0,
    description: '',
    code: '',
  }

  public funcEdit(item, index, button) {
    //  console.log(item)
    this.postData.id = item.id
    this.postData.description = item.description
    this.postData.code = item.code
    this.$root.$emit('bv::show::modal', 'modal-edit', button)
  }

  public get stateDescription() {
    return this.postData.description.length > 4 ? true : false
  }

  public resetEditModal() {
    this.code = ''
    this.description = ''
  }
  public patchNotif(item, index, button) {
    const dataToEdit = {
      id: this.postData.id,
      code: this.postData.code,
      description: this.postData.description,
    }
    PositionDataModule.updatePosition(dataToEdit)
    this.$root.$emit('bv::hide::modal', 'modal-edit', button)
  }
}
